// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1NNlO","footer":"ModalCreateQualiphyProcedure_footer__2spZb","additionData":"ModalCreateQualiphyProcedure_additionData__3mywL"};